module.exports = __webpack_public_path__ + "img/product-xindai.04ebafc6.svg";